import {Flex, Text} from '@priority-software/priority-style-react';
import React, {useState} from 'react';
import cx from 'classnames';
import styles from '../styles.module.scss';
import {ChartConfig} from '../../types';
import {genKPIChartData} from '../../serialize';
import {reportWebSdkService} from '../../services/reportWebSdkService';
import {reportGeneratorsStore} from '../../stores/ReportGeneratorsStore';
import {CircularLoader} from '../../../../components/CircularLoader/CircularLoader';
import {prepareInputsData} from './utils';

export const KPI = ({config}: {config: ChartConfig}) => {
    const [isLoadingExplanatoryReport, setIsLoading] = useState<boolean>(false);

    const value = genKPIChartData(config);

    const onDataPlotClick = async () => {
        const {currentScreen} = reportGeneratorsStore;
        if (config.explanatoryReport && currentScreen) {
            setIsLoading(true);
            const reportInputsMetaData = prepareInputsData(config);
            currentScreen.setCurrExpRepTitle(config.explanatoryReport.Title);
            currentScreen.setExpReportInputsMetaData(reportInputsMetaData);
            await reportWebSdkService.startProc();
            setIsLoading(false);
        }
    };

    return (
        <>
            <Flex
                direction="column"
                justifyContent="space-between"
                alignItems="center"
                componentClasses={styles.kpiContainer}
            >
                <Text skin="caption-1" style={{fontSize: '32px'}}>
                    {config?.chartName || ''}
                </Text>
                <Text
                    skin="caption-2"
                    componentClasses={cx(styles.kpiValue, {
                        [styles.clickableValue]: config?.explanatoryReport
                    })}
                    style={{fontSize: '120px'}}
                    onClick={onDataPlotClick}
                >
                    {value}
                </Text>
            </Flex>
            {isLoadingExplanatoryReport && (
                <div style={{position: 'absolute'}}>
                    <CircularLoader />
                </div>
            )}
        </>
    );
};
